<template>
    <div class="main">
        <canvas class="noise" id="noiseLayer" ref="noiseLayer"></canvas>

        <div class="caption">
            NOTHING
        </div>
    </div>
</template>

<script>
//https://dev.to/ekeijl/retro-crt-terminal-screen-in-css-js-4afh

function NoiseLayer(canvas) {
    const context = canvas.getContext('2d');
    let frame = 0;
    let normalBrightness = 0;
    let maxNormalBrightness = 100;
    const redraw = () => {
        if (frame % 5 == 0 && canvas.width < 100) {
            canvas.width++;
            canvas.height++;
        }
        if (frame % 5 == 0 && normalBrightness < maxNormalBrightness) {
            normalBrightness++;
        }

        const brightness = Math.random() > 0.95 ? normalBrightness * 1.55 : normalBrightness;
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const idata = imageData.data;
        for (var i = 0; i < idata.length; i += 4) {
            idata[i] = idata[i + 1] = idata[i + 2] = Math.floor(Math.random() * brightness);
            idata[i + 3] = 255;
        }
        context.putImageData(imageData, 0, 0);
        frame++;
        window.requestAnimationFrame(redraw);
    };
    canvas.width = 1;
    canvas.height = 1;
    window.requestAnimationFrame(redraw);
}

export default {
    data() {
        return {

        };
    },

    mounted() {
        NoiseLayer(this.$refs.noiseLayer);
    },

    methods: {

    }
}

</script>

<style scoped>

.main {
    position: relative;
}

.noise {
    width: 100%;
    height: 100vh;
}

.caption {
    position: absolute;
    top: 20vh;
    left: 0;
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 10vw;
    font-family: Monospaced;
    opacity: 1;
    color: rgba(0, 0, 0, 0.1);
    text-shadow: 0 0 10px rgba(1, 1, 1, 0.8);
}

</style>



// WEBPACK FOOTER //
// src/components/Nothingness.vue